module.exports = __webpack_public_path__ + "img/4_125.e5e4465f.png";